export const environment = {
    production: false,
    ENVIRONMENT_NAME:"preproduction",
    BASE_URL : "https://api.preprodsaisine.mediation-eau.fr",
    PARENT_URL: "https://preprod.mediation-eau.fr",
    HOST_SITE : "https://preprod.mediation-eau.fr/",
    CONTACT_PAGE : "https://preprod.mediation-eau.fr/FR/contact/abonne-et-requerant.asp",
    LIEN_ESPACE_ABONNE: "https://preprod.abonnes.mediation-eau.fr/connexion",
    EXCLUDE_URL: "https://preprod.mediation-eau.fr/FR/votre-saisine/saisine.asp"
}